
  import { computed, defineComponent, PropType } from "vue"
import injectStrict from "@/utils/injectStrict"
import { translationKey } from "@/symbols"
import { RelatedResourceData } from "@/models/RelatedResourceData"
import getResourceSvg from "@/services/relatedResourceSvgProvider"
import { container } from "tsyringe"
import { AnalyticsClient } from "@/services/AnalyticsService"
import { AwEventType } from "@/models/AwEventType"
export default defineComponent({
  props: {
    resources: { type: Object as PropType<Array<RelatedResourceData>>, required: false },
    allowaccess: { type: Boolean, required: false, default: true }
  },
  setup(props) {
    var showRelatedResources = computed(() => props.resources && props.resources.length > 0)
    const analytics = container.resolve(AnalyticsClient)

    let onClick = (res: RelatedResourceData) => {
      if (res.id) analytics.register({ eventType: AwEventType.ResourceClicked, relatedResourceId: res.id }, null)
    }

    const { translateResource, translateLabels } = injectStrict(translationKey)
    return { showRelatedResources, getResourceSvg, onClick, translateResource, translateLabels }
  },
  methods: {
    getResourceLabel(lbl: string): string {
      switch (lbl) {
        case "WEB":
          return this.translateLabels("Web") ?? ""
          break
        case "INFOGRAPHIC":
          return this.translateLabels("Infographic") ?? ""
          break
        case "EBOOK":
          return this.translateLabels("eBook") ?? ""
          break
        case "BLOGPOST":
          return this.translateLabels("Blog") ?? ""
          break
        case "WEBINAR":
          return this.translateLabels("Webinar") ?? ""
          break
        case "VIDEO":
          return this.translateLabels("Video") ?? ""
          break
        case "PAPER":
          return this.translateLabels("White Paper") ?? ""
          break
        case "SLIDEDECK":
          return this.translateLabels("Slides") ?? ""
          break
        case "ARTICLE":
          return this.translateLabels("Article") ?? ""
          break
        default:
          throw new Error(this.translateLabels("Icon not found exception ") ?? "")
          break
      }
    },
    shouldDownload(r: RelatedResourceData) {
      // determine based on resource type
      const label = this.getResourceLabel(r.icon).toUpperCase()
      // these types should be downloaded
      const downloadable = ["EBOOK", "PAPER", "INFOGRAPHIC", "SLIDEDECK"]
      return downloadable.includes(label)
    },

    sanitizeFileName(title: string) {
      return title.replace(/[\\/:*?"<>|]/g, "_")
    },
    async onResourceClick(r: RelatedResourceData) {
      if (!this.shouldDownload(r)) {
        window.open(r.link, "_blank")
        return
      }

      const title = this.sanitizeFileName(this.translateResource(r).title)

      try {
        const response = await fetch(r.link)
        if (!response.ok) throw new Error(`Failed to fetch resource: ${response.statusText}`)

        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)

        const a = document.createElement("a")
        a.href = url
        a.download = title // 👈 no extension added here
        a.click()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error("Download failed:", error)
        window.open(r.link, "_blank") // fallback if fetch fails
      }
    },
  }
})
